import { NAVIGATION_COMPONENT_TYPE } from 'constant/NavigationConstant';
import { MyViewItemConfig } from 'types/api/Tenant/ConfigurationTypes';

interface ExistingMyViewSelection {
  componentId: string;
  componentType: string;
  subjectId?: string | null;
}

export function getMyViewSelectionId(componentId: string, componentType: string, subjectId?: string | null): string {
  if (componentType !== NAVIGATION_COMPONENT_TYPE.EVENT || !subjectId) {
    return componentId;
  }

  const subjectSuffix = `#${subjectId}`;
  return componentId.endsWith(subjectSuffix) ? componentId : `${componentId}${subjectSuffix}`;
}

export function getOrderedMyViewSelection(
  items: MyViewItemConfig[],
  selectedItemIds: ReadonlySet<string>,
  existingRows: ExistingMyViewSelection[] = []
): MyViewItemConfig[] {
  const selectedItemsById = new Map(
    items.filter((item) => selectedItemIds.has(item.id)).map((item) => [item.id, item])
  );
  const orderedItems: MyViewItemConfig[] = [];
  const addedItemIds = new Set<string>();

  existingRows.forEach((row) => {
    const selectionId = getMyViewSelectionId(row.componentId, row.componentType, row.subjectId);
    const item = selectedItemsById.get(selectionId);
    if (item && !addedItemIds.has(item.id)) {
      orderedItems.push(item);
      addedItemIds.add(item.id);
    }
  });

  items.forEach((item) => {
    if (selectedItemIds.has(item.id) && !addedItemIds.has(item.id)) {
      orderedItems.push(item);
      addedItemIds.add(item.id);
    }
  });

  return orderedItems;
}

export function normalizeMyViewItemOrder<T>(items: T[]): Array<T & { colIndexOrder: number }> {
  return items.map((item, index) => ({ ...item, colIndexOrder: index + 1 }));
}
